<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺ID">
                  <el-input type="number" v-model.number="queryForm.inputVendorId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺名称">
                  <el-select v-model="queryForm.vendorId" filterable clearable placeholder="店铺">
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="取消率类型">
                  <el-select v-model="queryForm.cancelRateTypeCode" clearable>
                    <el-option v-for="item in cancelRateTypeList" :label="item.dataDictionaryValue" :value="item.dictCode" :key="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="渠道">
                  <el-select v-model="queryForm.channelTypeCode" clearable>
                    <el-option v-for="item in channelTypeList" :label="item.dictName" :value="item.dataDictionaryValue" :key="item.dataDictionaryValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="到大陆时长（天）" label-width="130px">
                  <el-select v-model="queryForm.arrivalTimeCode" clearable>
                    <el-option v-for="item in arrivalTimeList" :label="item.dataDictionaryValue" :value="item.dictCode" :key="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="showForm">新增配置</el-button>
      <el-button type="primary" @click="exportData" :disabled="tableData.length == 0">导出</el-button>
      <el-button type="text" @click="downloadTemplate">导入模板</el-button>
      <div class="upload-wrap">
        <el-button type="primary" icon="el-icon-upload">导入</el-button>
        <input @change="changeFile" accept=".xlsx" type="file">
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="vendorId" label="店铺ID"></el-table-column>
      <el-table-column prop="vendorName" label="店铺名称"></el-table-column>
      <el-table-column prop="channelType" label="渠道"></el-table-column>
      <el-table-column prop="cancelRateType" label="取消率类型"></el-table-column>
      <el-table-column prop="typeName" label="时长类型"></el-table-column>
      <el-table-column prop="arrivalTime" label="到大陆时长（天）"></el-table-column>
      <el-table-column prop="hongKongTimeValue" label="到港时长（天）"></el-table-column>
      <el-table-column prop="macaoTimeValue" label="到澳门时长（天）"></el-table-column>
      <el-table-column prop="northAmericaTimeValue" label="到北美时长（天）"></el-table-column>
      <el-table-column prop="addressCountry" label="国家"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">编辑</el-link>
          <el-link type="primary" class="ml10" @click="delItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[25, 50, 100, 200]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.id ? '编辑配置' : '新增配置'" :visible.sync="dialogVisible" width="450px">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item prop="vendorId" label="店铺名称" :rules="[{ required: true, message: '请选择店铺' }]">
          <el-select v-model="form.vendorId" filterable placeholder="店铺" :disabled="form.id">
            <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="cancelRateTypeCode" label="取消类型" :rules="[{ required: true, message: '请选择取消类型' }]">
          <el-select v-model="form.cancelRateTypeCode">
            <el-option v-for="item in cancelRateTypeList" :label="item.dataDictionaryValue" :value="item.dictCode" :key="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="channelTypeCode" label="渠道类型" :rules="[{ required: true, message: '请选择渠道类型' }]">
          <el-select v-model="form.channelTypeCode" :disabled="form.id">
            <el-option v-for="item in channelTypeList" :label="item.dictName" :value="item.dataDictionaryValue" :key="item.dataDictionaryValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="arrivalTimeCode" label="到大陆时长（天）" :rules="[{ required: true, message: '请选择到大陆时长' }]">
          <el-select v-model="form.arrivalTimeCode" @change="changeArrivalTime">
            <el-option v-for="item in arrivalTimeList" :label="item.dataDictionaryValue" :value="item.dictCode" :key="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到港时长（天）">{{ form.hongKongTimeValue }}</el-form-item>
        <el-form-item label="到澳门时长（天）">{{ form.macaoTimeValue }}</el-form-item>
        <el-form-item label="到北美时长（天）">{{ form.northAmericaTimeValue }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="导入" :visible.sync="dialogVisible2" width="400px" :close-on-click-modal="false">
      <p>导入文件中有错误行，请<el-link @click="downloadResult" type="primary">下载文件</el-link>根据错误提示处理之后重新上传</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import {
  getVendorExtDict,
  getVendorConfigureList,
  getVendorConfigureTimeValue,
  saveVendorConfigure,
  updateVendorConfigure,
  delVendorConfigure,
  exportVendorConfigureList,
  importVendorConfigureList,
} from "../api";
import { fileUpload, getVendorsByVendorName } from '../../../../api/merchants_cn';

export default {
  components: {
  },
  data() {
    return {
      fullscreenLoading: false,
      vendorList: [],
      arrivalTimeList: [],
      arrivalTimeMap: {},
      channelTypeList: [],
      channelTypeMap: {},
      cancelRateTypeList: [],
      cancelRateTypeMap: {},
      queryForm: {
        inputVendorId: null,
        vendorId: null,
        cancelRateTypeCode: null,
        channelTypeCode: null,
        arrivalTimeCode: null,
        pageNo: 1,
        pageSize: 50,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        id: null,
        vendorId: null,
        cancelRateTypeCode: null,
        channelTypeCode: null,
        arrivalTimeCode: null,
        hongKongTimeValue: null,
        macaoTimeValue: null,
        northAmericaTimeValue: null,
      },
      dialogVisible2: false,
    };
  },
  mounted() {
    getVendorsByVendorName().then(res => {
      if (res.data) {
        this.vendorList = res.data;
      }
    })
    getVendorExtDict([
      'boutique_cancel_rate_type',
      'boutique_arrival_time',
      'boutique_channel_type',
    ]).then(res => {
      if (res.data && res.data.data) {
        this.arrivalTimeList = (res.data.data.boutique_arrival_time || []).map((item) => {
          this.arrivalTimeMap[item.dictCode] = item.dataDictionaryValue;
          return item;
        });
        this.channelTypeList = (res.data.data.boutique_channel_type || []).map((item) => {
          this.channelTypeMap[item.dataDictionaryValue] = item.dictName;
          return item;
        });
        this.cancelRateTypeList = (res.data.data.boutique_cancel_rate_type || []).map((item) => {
          this.cancelRateTypeMap[item.dictCode] = item.dataDictionaryValue;
          return item;
        });
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.inputVendorId = null;
      this.queryForm.vendorId = null;
      this.queryForm.cancelRateTypeCode = null;
      this.queryForm.channelTypeCode = null;
      this.queryForm.arrivalTimeCode = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getVendorConfigureList({
        ...this.queryForm,
        vendorId: this.queryForm.inputVendorId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = saveVendorConfigure;
            if (this.form.id) {
              request = updateVendorConfigure;
            }
            request({
              ...this.form,
              cancelRateType: this.cancelRateTypeMap[this.form.cancelRateTypeCode],
              arrivalTime: this.arrivalTimeMap[this.form.arrivalTimeCode],
              channelType: this.channelTypeMap[this.form.channelTypeCode],
            }).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success(this.form.id ? '编辑成功' : '创建成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.message || '系统异常，请稍后再试');
              }
            }).catch(() => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    delItem(row) {
      this.$confirm(`确认删除${row.vendorName}配置吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVendorConfigure(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    showForm() {
      this.form.id = null;
      this.form.vendorId = null;
      this.form.cancelRateTypeCode = null;
      this.form.channelTypeCode = null;
      this.form.channelType = null;
      this.form.arrivalTimeCode = null;
      this.form.hongKongTimeValue = null;
      this.form.macaoTimeValue = null;
      this.form.northAmericaTimeValue = null;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form.id = row.id;
      this.form.vendorId = row.vendorId;
      this.form.cancelRateTypeCode = row.cancelRateTypeCode;
      this.form.channelTypeCode = row.channelTypeCode;
      this.form.arrivalTimeCode = row.arrivalTimeCode;
      this.form.hongKongTimeValue = row.hongKongTimeValue;
      this.form.macaoTimeValue = row.macaoTimeValue;
      this.form.northAmericaTimeValue = row.northAmericaTimeValue;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    downloadUrl(url) {
      if (url) {
        downloadUrlFile(url);
      }
    },
    downloadTemplate() {
      this.downloadUrl('https://sha-oss-static.oss-cn-shanghai.aliyuncs.com/upload/%E4%B9%B0%E6%89%8B%E5%BA%97%E5%8F%96%E6%B6%88%E7%8E%87%E5%92%8C%E5%8F%91%E8%B4%A7%E6%97%B6%E9%95%BF%E6%A8%A1%E6%9D%BF.xlsx');
    },
    downloadResult() {
      this.downloadUrl(this.resultUrl);
    },
    exportData() {
      this.fullscreenLoading = true;
      exportVendorConfigureList({
        ...this.queryForm,
        vendorId: this.queryForm.inputVendorId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.success) {
          this.downloadUrl(res.data.data);
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        this.fullscreenLoading = false;
      }).catch(() => {
        this.$message.error('系统异常，请稍后再试');
        this.fullscreenLoading = false;
      });
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if (!/\.xlsx$/.test(String(file.name).toLowerCase())) {
          this.$message.error('上传文件格式非法，请上传xlsx文件');
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error('文件最大10m');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        await OSSClient.put(random_name, file);
        const res = await importVendorConfigureList({ fileName });
        if (res.data && res.data.success) {
          this.fullscreenLoading = false;
          this.getTableData();
          if (res.data.data) {
            this.resultUrl = res.data.data;
            this.dialogVisible2 = true;
          } else {
            this.$message.success('导入成功');
          }
        } else {
          this.fullscreenLoading = false;
          this.$message.error(res.data && res.data.message || '系统异常');
        }
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    changeArrivalTime(arrivalTimeCode) {
      getVendorConfigureTimeValue({
        arrivalTimeCode,
      }).then(res => {
        if (res.data && res.data.data) {
          this.form.hongKongTimeValue = res.data.data.hongKongTimeValue;
          this.form.macaoTimeValue = res.data.data.macaoTimeValue;
          this.form.northAmericaTimeValue = res.data.data.northAmericaTimeValue;
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
